"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isObject2 = _interopRequireDefault(require("lodash/isObject"));

var _striptags = _interopRequireDefault(require("striptags"));

var _he = require("he");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default(text) {
  if ((0, _isObject2.default)(text)) {
    text = text.content || '';
  }

  text = (0, _he.decode)((0, _striptags.default)(text).replace('&nbsp;', ' '));
  return text;
};

exports.default = _default;